import { combineReducers } from 'redux'

import loads from './reducers/loadsReducer'
import opportunityLoads from './reducers/opportunityLoadsReducer'
import selectedLoad from './reducers/selectedLoadReducer'
import externalLoads from './reducers/externalLoadsReducer'
import authenticatedUser from './reducers/authenticatedUser'
import selectedLoadScreenTable from './reducers/selectedLoadScreenTableReducer'
import matchedTrucks from './reducers/matchedTrucksReducer'
import selectedCarrier from './reducers/selectedCarrierReducer'
import leadData from './reducers/leadsLoadReducer'
import carriersOwned from './reducers/carriersOwnedReducer' // TODO: REMOVE
import carrierLeads from './reducers/carrierLeadsReducer' // TODO: REMOVE
import carrierSearchList from './reducers/carrierSearchListReducer'
import noteModal from './reducers/noteModalReducer'
import users from './reducers/userReducer.js'
import calls from './reducers/callReducer.js'
import selectedUser from './reducers/selectedUserReducer'
import trucks from './reducers/trucksReducer'
import truckEntrySelectedCarrier from './reducers/truckEntrySelectedCarrierReducer'
import truckEntryTruckList from './reducers/truckEntryTruckListReducer'
import messages from './reducers/messagesReducer'
import loadFilter from './reducers/loadFilterReducer'
import carrierMatchingLoads from './reducers/carrierMatchingLoadsReducer'
import selectedTruck from './reducers/selectedTruckReducer'
import eventList from './reducers/eventListReducer'
import selectedCarrierTruck from './reducers/selectedCarrierTruckReducer'
import inboxNotifications from './reducers/inboxNotificationsReducer'
import historicLoads from './reducers/historicLoadsReducer'
import userLoads from './reducers/userLoadsReducer'
import userLoadSpread from './reducers/userLoadSpreadReducer'
import selectedBid from './reducers/selectedBidReducer'
import historicLoadsForScreen from './reducers/historicLoadsScreenReducer'
import historicLoadsFilter from './reducers/historicLoadsFilterReducer'
import recentCustomers from './reducers/customer/customerRecentCustomersReducer'
import customerSearchList from "./reducers/customer/customerSearchListReducer"
import selectedCustomer from "./reducers/customer/selectedCustomerReducer"
import stats from './reducers/statsReducer'
import tasks from './reducers/tasksReducer'
import selectedTask from './reducers/selectedTaskReducer'
import matches from './reducers/matchesReducer'
import selectedMatch from './reducers/selectedMatchReducer'
import selectedLead from './reducers/selectedLeadReducer'
import emails from './reducers/emailsReducer'
import allTeams from './reducers/adminReducer'
import dialogs from './reducers/dialogReducer'
import queryCounterData from './reducers/queryCounterReducer'
import connectLogsData from './reducers/connectLogsReducer'
import truckStreamConnected from './reducers/truckStreamConnectedReducer'
import insightData from './reducers/insightDataReducer'
import allConnectLogs from './reducers/allConnectLogsReducer'
import datRates from './reducers/datRatesReducer'
import returnLoads from './reducers/returnLoadsForTruckReducer'
import smsQueueLogs from './reducers/smsQueueLogsReducer'
import historicLoadsByMc from './reducers/historicLoadsByMcReducer'
import connectMaps from './reducers/connectMapsReducer'
import connectMapsState from './reducers/connectMapsStateReducer'
import adminCustomersData from './reducers/adminCustomersReducer'
import connectQueueStatus from './reducers/connectQueueStatusReducer'
import carrierOpsTasks from './reducers/carrierOpsReducer'
import selectedCarrierOpsTask from './reducers/selectedCarrierOpsTaskReducer'
import modalDialog from './reducers/modalDialogReducer'
import carrierOpsTaskData from './reducers/carrierOpsTaskDataReducer'
import incomingTexts from './reducers/incomingTextsReducer'
import carrierOpsSelectedLoadTasks from './reducers/carrierOpsSelectedLoadTasksReducer'
import loadTaskFilter from './reducers/loadTaskFilterReducer'
import smsInboundNotifications from './reducers/smsInboundNotificationsReducer'
import newVersionAvailable from './reducers/newVersionAvailableReducer'
import loadTaskQuestions from './reducers/loadTaskQuestionsReducer'
import pusherConnectionStatus from './reducers/pusherConnectionStatusReducer'
import carrierFolders from './reducers/carrierFoldersReducer'
import customerLanes from './reducers/customer/customerLanesReducer'
import customerContacts from './reducers/customer/customerContactsReducer'
import customerFacilities from './reducers/customer/customerFacilitiesReducer'
import customerCustomers from './reducers/customer/customerCustomersReducer'
import carrierSelectedLoad from './reducers/carrierSelectedLoadReducer'
import carrierBids from './reducers/carrierBidsReducer'
import customerLumperData from './reducers/customerLumperDataReducer'
import userActivity from './reducers/userActivityReducer'
import truckSchedules from './reducers/truckSchedulesReducer'
import userCarriers from './reducers/userCarriersReducer'
import teams from './reducers/teamsReducer.js'
import userOwnedCarriers from './reducers/userOwnedCarriersReducer'
import carrierOwners from './reducers/carrierOwnersReducer'
import teamsAndUsers from './reducers/teamsAndUsersReducer'
import spreadRecapOptions from './reducers/spreadRecapOptionsReducer'
import checkCalls from './reducers/checkCallsReducer'
import loadPositions from './reducers/loadPositionsReducer'
import helpText from './reducers/helpTextReducer'
import bids from './reducers/bidsReducer'
import bidsFilter from './reducers/bidsFilterReducer'
import carrierQueuesSchedule from './reducers/carrierQueuesScheduleReducer'
import pricingLoads from './reducers/pricingLoadsReducer'
import selectedPricingLoad from './reducers/selectedPricingLoadReducer'
import commission from './reducers/commissionReducer'
import customerSourcingLanes from './sourcing/customerSourcingLanesReducer'
import laneLoadStats from './sourcing/laneLoadStatsReducer.js'
import laneOffers from './sourcing/laneOffersReducer.js'
import loadBounties from './bounty/loadBountiesReducer.js'
import userBountyBudgets from './bounty/userBountyBudgetsReducer.js'
import loadBountiesFilter from './bounty/loadBountiesFilterReducer.js'

const combinedReducers = combineReducers({
    loads,
    leadData,
    opportunityLoads,
    selectedLoad,
    externalLoads,
    authenticatedUser,
    selectedLoadScreenTable,
    matchedTrucks,
    selectedCarrier,
    carriersOwned, // TODO: REMOVE
    carrierLeads, // TODO: REMOVE
    dialogs,  //TODO: we should use one reducer to store all dialog visibility
    carrierSearchList,
    noteModal,  //TODO: do we need models in the store?  we should use one reducer to store all dialog visibility
    users,
    calls,  //TODO: do we need this?
    selectedUser,
    trucks,
    truckEntrySelectedCarrier,
    truckEntryTruckList,
    messages,
    loadFilter,
    carrierMatchingLoads,
    allTeams,
    selectedTruck,
    eventList,
    selectedCarrierTruck,
    selectedLead,
    inboxNotifications,  //TODO: remove this
    historicLoads,
    userLoads,
    selectedBid,
    historicLoadsForScreen,
    historicLoadsFilter,
    recentCustomers,
    customerSearchList,
    selectedCustomer,
    stats,
    tasks,
    selectedTask,
    matches,
    selectedMatch,
    emails,
    queryCounterData,
    connectLogsData,
    truckStreamConnected,
    insightData,
    allConnectLogs,
    datRates,
    returnLoads,
    userLoadSpread,
    smsQueueLogs,
    historicLoadsByMc,
    connectMaps,
    connectMapsState,
    adminCustomersData,
    connectQueueStatus,
    carrierOpsTasks,
    selectedCarrierOpsTask,
    carrierOpsTaskData,
    incomingTexts,
    modalDialog,
    carrierOpsSelectedLoadTasks,
    loadTaskFilter,
    smsInboundNotifications,
    newVersionAvailable,
    loadTaskQuestions,
    pusherConnectionStatus,
    carrierFolders,
    customerLanes,
    customerContacts,
    customerFacilities,
    customerCustomers,
    carrierSelectedLoad,
    carrierBids,
    customerLumperData,
    userActivity,
    truckSchedules,
    userCarriers,
    userOwnedCarriers,
    teams,
    carrierOwners,
    teamsAndUsers,
    spreadRecapOptions,
    checkCalls,
    loadPositions,
    helpText,
    bids,
    bidsFilter,
    carrierQueuesSchedule,
    pricingLoads,
    selectedPricingLoad,
    commission,
    customerSourcingLanes,
    laneLoadStats,
    laneOffers,
    loadBounties,
    userBountyBudgets,
    loadBountiesFilter
})

const rootReducer = (state, action) => {
  return combinedReducers(state, action)
}

//accessor functions into the store, used by yield select
export const getLoadFilter = state => state.loadFilter
export const getLoads = state => state.loads
export const getSelectedLoad = state => state.selectedLoad
export const getSelectedLead = state => state.selectedLead
export const getCarriersOwned = state => state.carriersOwned
export const getCarrierLeads = state => state.carrierLeads
export const getMatchedTrucks = state => state.matchedTrucks
export const getCurrentUser = state => state.authenticatedUser
export const getSelectedCarrier = state => state.selectedCarrier
export const getHistoricLoads = state => state.historicLoads
export const getRecentCustomers = state => state.recentCustomers
export const getMyAssignments = state => state.myAssignments   // TODO: remove after removing references in customer assignments dead code
export const getEmails = state => state.emails
export const getQueryCounterData = state => state.queryCounterData
export const getConnectLogsData = state => state.connectLogsData
export const getAllConnectLogs = state => state.allConnectLogs
export const getCarrierMatchingLoads = state => state.carrierMatchingLoads
export const getTasks = state => state.tasks
export const getSelectedTask = state => state.selectedTask
export const getMatches = state => state.matches
export const getTruckEntryTruckList = state => state.truckEntryTruckList
export const getReturnLoads = state => state.returnLoads
export const getSmsQueueLogs = state => state.smsQueueLogs
export const getHistoricLoadsByMc = state => state.historicLoadsByMc
export const getConnectMaps = state => state.connectMaps
export const getConnectMapsState = state => state.connectMapsState
export const getConnectQueueStatus = state => state.connectQueueStatus
export const getCarrierOpsTasks = state => state.carrierOpsTasks
export const getSelectedCarrierOpsTask = state => state.selectedCarrierOpsTask
export const getCarrierOpsTaskData = state => state.carrierOpsTaskData
export const getIncomingTexts = state => state.incomingTexts
export const getCarrierOpsSelectedLoadTasks = state => state.carrierOpsSelectedLoadTasks
export const getLoadTaskFilter = state => state.loadTaskFilter
export const getLoadTaskQuestioons = state => state.loadTaskQuestions
export const getSelectedCarrierTruck = state => state.selectedCarrierTruck
export const getCarrierOwners = state => state.carrierOwners
export const getBidsFilter = state => state.bidsFilter
export const getBids = state => state.bids
export const getPricingLoads = state => state.pricingLoads
export const getSelectedPricingLoad = state => state.selectedPricingLoad
export const getLoadBountiesFilter = state => state.loadBountiesFilter

export default rootReducer